import { Component, OnDestroy, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { ClockOverlayService } from "../../providers/clock-overlay.service";
import { BvDialogRef } from "../../design-system";
import { BountyRevealComponent } from "./bounty-reveal.component";

// Initiating-device host for the mystery-bounty reveal — opened locally by the
// device that drew (mirrors the Break Table modal). Renders the SAME reveal
// component as the fullscreen clock, fed from the shared clockOverlay node, so
// the two stay in lock-step. Closes when the reveal finishes (done → dismiss the
// node) or when the node is cleared by any surface.
@Component({
  selector: "app-bounty-reveal-dialog",
  template: `
    @if (overlay$ | async; as overlay) {
      @if (overlay.type === 'mysteryBounty') {
        <app-bounty-reveal
          [draws]="overlay.draws || []"
          [order]="overlay.order || []"
          [atTs]="overlay.timestamp"
          (done)="onDone()"
        ></app-bounty-reveal>
      }
    }
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100vw;
        height: 100dvh;
      }
    `,
  ],
  imports: [AsyncPipe, BountyRevealComponent],
})
export class BountyRevealDialogComponent implements OnDestroy {
  private overlayService = inject(ClockOverlayService);
  private dialogRef = inject(BvDialogRef);

  overlay$ = this.overlayService.overlay;

  private sawBounty = false;
  private closed = false;
  private sub: Subscription;
  private fallback: any;

  constructor() {
    this.sub = this.overlayService.overlay.subscribe((o) => {
      if (o && o.type === "mysteryBounty") {
        if (!this.sawBounty) {
          this.sawBounty = true;
          // Safety net, scaled by the number of draws (a batch ceremony is long).
          const n = (o.draws && o.draws.length) || 1;
          this.fallback = setTimeout(() => this.close(), 8000 * n + 15000);
        }
      } else if (this.sawBounty) {
        this.close(); // node cleared elsewhere → close
      }
    });
  }

  onDone() {
    this.overlayService.dismiss(); // remove node → all surfaces clear together
    this.close();
  }

  private close() {
    if (this.closed) return;
    this.closed = true;
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    if (this.fallback) clearTimeout(this.fallback);
  }
}
